import React, { Component } from 'react';
import Page from '../components/Page';
import { Container, Grid, Paper } from '@mui/material';
import { connect } from 'react-redux';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';

class Contact extends Component {
	render() {
		return (
			<Page title="Contact" icon={<PhoneIphoneIcon />}>
				<Container style={{ marginTop: '50px', width: '40%', padding: '10px' }}>
					<Paper elevation={10}>
						<Grid container sx={{ textAlign: 'center' }}>
							<Grid sx={{ width: '100%' }}>
								<div style={{ margin: '15px' }}>
									<h2>Contact Us</h2>
									<br />
									<p>You can contact us for get more information about tiers and more.</p>
									<p>
										<br />
										E-mail: <a href="mailto:info@maytapi.com">info@maytapi.com</a>
										<br />
										{/* WhatsApp:{' '}
										<a
											href="https://api.whatsapp.com/send?phone=908503464798&text=Hello,I want to ask about Maytapi."
											target="_blank"
											rel="noopener noreferrer"
										>
											+908503464798
										</a> */}
									</p>
								</div>
							</Grid>
						</Grid>
					</Paper>
				</Container>
			</Page>
		);
	}
}

const stateToProps = (state) => ({ access: state.access, product: state.product.maytapi, location: state.router.location });
export default connect(stateToProps)(Contact);
